import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

//Hooks
import { useDispatch, useSelector } from 'react-redux';

//Actions
import * as actions from '../../../../store/actions';

//Components
import { Container } from 'react-bootstrap';
import { Redirect, useParams } from 'react-router-dom';
import Loader from 'react-loader-spinner';
import { Box } from 'react-feather';

//Styles
import Styles from './Bundles.module.scss';
import ServiceOptions from '../../../../components/ServiceOptions/ServiceOptions';

import { ROUTER_URL } from '../../../../const/ROUTER_URL';

const Bundles = () => {
    const { shopId } = useParams();
    const { t } = useTranslation('common');
    const bundles = useSelector(state => state.bundles.bundles);
    const status = useSelector(state => state.bundles.status);
    const style = useSelector(state => state.widget.style);
    const {
        bundles: showBundles,
        services: showServices,
        groups: showGroups,
        events: showEvents,
    } = useSelector(state => state.companies.shop ? state.companies.shop.products : {
        services: false,
        groups: false,
        events: false,
        bundles: true
    });
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(actions.selectService(null));
        dispatch(actions.selectGroup(null));
        dispatch(actions.selectEvent(null));
    }, [dispatch]);

    useEffect(() => {
        dispatch(actions.getBundlesAll())
    }, [status, dispatch]);

    if (!showBundles) {
        return (showServices || showGroups || showEvents) ? (
            <Redirect
                to={ROUTER_URL.SHOPS_ID({ shopId })}
                exact
            />
        ) : (
            <div className={Styles.centeredContainer}>
                <Box className={Styles.noBundlesIcon} size={58}/>

                <span className={Styles.noBundlesMessage}>
                    {t('homeScreen.noServicesFound')}
                </span>
            </div>
        );
    }

    return (
        <Container
            className={[
                Styles.container,
                (style === 'dev' || style === 'website') ? Styles.website : ''
            ].join(' ')}
        >
            {!bundles && (
                <div className={Styles.centeredContainer}>
                    <Loader
                        type={'TailSpin'}
                        color={'#000'}
                        width={48}
                        height={48}
                    />
                </div>
            )}

            {bundles && bundles.length !== 0 && (
                <div className="w-100">
                    {bundles.map(bundle => (
                        <ServiceOptions
                            key={`bundle-${bundle.id}`}
                            bundle={bundle}
                            type={'bundle'}
                            to={
                                bundle.reservation_id !== null
                                    ? ROUTER_URL.RESERVATIONS_DETAILS_TYPE_ID_NEXT({
                                        reservationType: 'bundle',
                                        reservationId: bundle.reservation_id,
                                        next: 1,
                                    })
                                    : ROUTER_URL.SHOPS_ID_BUNDLES_ID({ shopId, bundleId: bundle.id })
                            }
                        />
                    ))}
                </div>
            )}

            {bundles && bundles.length === 0 && (
                <div className={Styles.centeredContainer}>
                    <Box className={Styles.noBundlesIcon} size={58}/>

                    <span className={Styles.noBundlesMessage}>
                        {t('homeScreen.noBundlesFound')}
                    </span>
                </div>
            )}
        </Container>
    )
};

export default Bundles
